import { api } from '../api';

export interface Vehicle {
  id: string;
  marca: string;
  modelo: string;
  tipo: 'carro' | 'moto' | 'caminhao' | 'outro';
  placa: string;
  ano: number;
  cor: string;
  observacoes?: string;
  foto?: string;
  tenantId: string;
  tenantName?: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: unknown;
}

export const vehicleService = {
  list: async () => {
    const response = await api.get<Vehicle[]>('/vehicles');
    return response;
  },

  getById: async (id: string) => {
    const response = await api.get<Vehicle>(`/vehicles/${id}`);
    return response;
  },

  create: async (data: Omit<Vehicle, 'id' | 'createdAt' | 'updatedAt'>) => {
    const response = await api.post<Vehicle>('/vehicles', data);
    return response;
  },

  update: async (id: string, data: Partial<Omit<Vehicle, 'id' | 'createdAt' | 'updatedAt'>>) => {
    const response = await api.put<Vehicle>(`/vehicles/${id}`, data);
    return response;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/vehicles/${id}`);
    return response;
  },
}; 